// Client del catálogo de reportes. El `run` es síncrono: responde 201 con el CSV en el cuerpo.
// La traducción de ambas respuestas vive en `reportsMapper.ts`.
import { apiFetch } from '../../../client';
import type {
    ReportCatalog,
    ReportCatalogWire,
    ReportFormat,
    ReportPeriod,
    ReportRunResult,
    ReportRunResultWire,
    ReportsApi,
} from './reportsContract';
import { toReportCatalog, toReportRunResult } from './reportsMapper';

const BASE_URL = import.meta.env.VITE_API_RETAIL_WIZARD_BASE_URL;

export const reportsClient: ReportsApi = {
    getCatalog: async (): Promise<ReportCatalog> =>
        toReportCatalog(
            await apiFetch<ReportCatalogWire>('/backoffice/reports', { baseUrl: BASE_URL }),
        ),
    runReport: async (
        reportId: string,
        format: ReportFormat,
        period?: ReportPeriod,
    ): Promise<ReportRunResult> =>
        toReportRunResult(
            await apiFetch<ReportRunResultWire>(
                `/backoffice/reports/${encodeURIComponent(reportId)}/run`,
                {
                    method: 'POST',
                    body: JSON.stringify({
                        format,
                        periodFrom: period?.from,
                        periodTo: period?.to,
                    }),
                    baseUrl: BASE_URL,
                },
            ),
        ),
};
